module.exports = __webpack_public_path__ + "img/logo.8ce24b21.png";